import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Spinner } from 'react-bootstrap';
import { Table } from '@rd-web-markets/shared/dist/util';
import { DeleteButton, DownloadButton } from '@rd-web-markets/shared/dist/util/buttons';
import { formatDateTimeLocaleWithTime } from '../util/date/dateUtils';
const ProjectTemplateExportsTable = _ref => {
  let {
    exports = [],
    loading,
    onDelete,
    userCanDelete
  } = _ref;
  const {
    t
  } = useTranslation();
  const getStatusBadge = status => {
    const statusConfig = {
      pending: {
        bg: 'warning',
        text: t('pending')
      },
      completed: {
        bg: 'success',
        text: t('completed')
      },
      failed: {
        bg: 'danger',
        text: t('failed')
      }
    };
    const config = statusConfig[status] || statusConfig.pending;
    return /*#__PURE__*/React.createElement(Badge, {
      bg: config.bg
    }, config.text, status === 'pending' && /*#__PURE__*/React.createElement(Spinner, {
      as: "span",
      animation: "border",
      size: "sm",
      role: "status",
      "aria-hidden": "true",
      className: "ms-2"
    }));
  };
  const handleDelete = async (index, row) => {
    if (window.confirm(t('confirm_delete_export'))) {
      await onDelete(row.exportItem.id);
    }
  };
  const headers = useMemo(() => [{
    text: t('status'),
    width: '15%'
  }, {
    text: t('created_by'),
    width: '20%'
  }, {
    text: t('created_at'),
    width: '20%'
  }, {
    text: t('time_elapsed'),
    width: '10%'
  }, {
    text: t('errors'),
    width: '25%'
  }, {
    text: '',
    width: '20%'
  }], [t]);
  const rows = useMemo(() => {
    return exports.map(exportItem => {
      var _exportItem$error_mes;
      const columns = [getStatusBadge(exportItem.status), /*#__PURE__*/React.createElement("small", null, exportItem.created_by || '-'), /*#__PURE__*/React.createElement("small", null, formatDateTimeLocaleWithTime(exportItem.created_at) || '-'), exportItem.elapsed_seconds != null ? /*#__PURE__*/React.createElement("small", null, exportItem.elapsed_seconds, "s") : /*#__PURE__*/React.createElement("small", {
        className: "text-muted"
      }, "-"), exportItem.status === 'failed' && ((_exportItem$error_mes = exportItem.error_messages) === null || _exportItem$error_mes === void 0 ? void 0 : _exportItem$error_mes.length) > 0 ? /*#__PURE__*/React.createElement("small", {
        className: "text-danger"
      }, exportItem.error_messages.map((err, idx) => /*#__PURE__*/React.createElement("div", {
        key: idx
      }, err.message))) : /*#__PURE__*/React.createElement("small", {
        className: "text-muted"
      }, "-"), /*#__PURE__*/React.createElement("div", {
        className: "d-flex justify-content-end gap-2"
      }, exportItem.status === 'completed' && exportItem.download_link ? /*#__PURE__*/React.createElement(DownloadButton, {
        size: "sm",
        variant: "info",
        onClick: () => window.open(exportItem.download_link.url, '_blank')
      }, t('download')) : null, userCanDelete && /*#__PURE__*/React.createElement(DeleteButton, {
        size: "sm",
        onClick: () => handleDelete(null, {
          exportItem
        }),
        disabled: loading
      }))];
      return {
        key: exportItem.id,
        exportItem: exportItem,
        columns: columns
      };
    });
  }, [exports, loading, userCanDelete, t]);
  if (exports.length === 0 && !loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "text-center py-4"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-muted mb-0"
    }, t('no_exports_yet')));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "project-template-exports-table"
  }, /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows,
    showControls: false,
    opts: {
      bordered: false,
      striped: true,
      responsive: true,
      hover: true,
      headerSticky: true
    },
    style: {
      borderCollapse: 'collapse'
    }
  }));
};
export default ProjectTemplateExportsTable;